module.exports = __webpack_public_path__ + "img/Home-06.3119fad8.svg";